import { Routes } from '@angular/router';

export const AppRoutes: Routes = [

];
